import {Signal} from '@angular/core';
import {toObservable, toSignal} from '@angular/core/rxjs-interop';
import {debounceTime, distinctUntilChanged} from 'rxjs/operators';

/**
 * Version stabilisée d'un signal : la valeur n'est propagée qu'après `delayMs` d'inactivité,
 * et jamais deux fois la même valeur consécutive.
 *
 * `comparator` est indispensable pour un signal d'objet, dont la référence change à chaque calcul :
 * sans lui, le dédoublonnage ne verrait jamais deux valeurs identiques.
 *
 * À appeler dans un contexte d'injection (initialisation de propriété d'un composant ou d'un service) :
 * la souscription et sa libération sont prises en charge par `toSignal`.
 */
export const debouncedSignal = <T>(source: Signal<T>, delayMs: number,
                                   comparator?: (previous: T, current: T) => boolean): Signal<T> =>
  toSignal(toObservable(source).pipe(debounceTime(delayMs), distinctUntilChanged(comparator)),
    {initialValue: source()});
